import React from 'react';

// Inline SVG to avoid extra HTTP request and enable faster rendering
const CalendarDeferredIcon = React.memo(props => (
  <svg {...props} width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="44" height="44" rx="8" fill="#F8F7FF" />
    <path
      d="M31 17.5V16C31 15.4696 30.7893 14.9609 30.4142 14.5858C30.0391 14.2107 29.5304 14 29 14H15C14.4696 14 13.9609 14.2107 13.5858 14.5858C13.2107 14.9609 13 15.4696 13 16V30C13 30.5304 13.2107 31.0391 13.5858 31.4142C13.9609 31.7893 14.4696 32 15 32H18.5"
      stroke="#203A9B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M26 12V16" stroke="#203A9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 12V16" stroke="#203A9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 20H18" stroke="#203A9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M27.5 27.5L26 26.3V24" stroke="#203A9B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M26 32C29.3137 32 32 29.3137 32 26C32 22.6863 29.3137 20 26 20C22.6863 20 20 22.6863 20 26C20 29.3137 22.6863 32 26 32Z"
      stroke="#203A9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

CalendarDeferredIcon.displayName = 'CalendarDeferredIcon';

export default CalendarDeferredIcon;
